import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Grid,
  Link as MUILink,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import OasisLogo from '../../assets/logo/Logo.svg';
import {
  footerMenuOptions,
  landingOptions,
  menuOptions,
} from '../../utils/menuOptions';
import { Link, useNavigate } from 'react-router-dom';
import { contactData } from '../../utils/contactData';
import SocialMedia from '../shared/SocialMedia';

const footerStyles = {
  sx: { color: (currTheme) => currTheme.palette.grey[500] },
  variant: 'body2',
  underline: 'hover',
  component: Link,
  textAlign: 'center',
};

const Divider = () => (
  <Typography
    sx={{
      fontWeight: '100',
      fontSize: '2rem',
      mx: 2,
      color: (currTheme) => currTheme.palette.grey[500],
      display: 'inline-block',
    }}>
    |
  </Typography>
);

// TODO: Aviso de privacidad

const Footer = ({ displayFooter }) => {
  const navigate = useNavigate();
  // Return empty fragment if displayFooter is false

  const handleItemClick = (option) => {
    if (landingOptions.includes(option.id)) {
      window.location.href = option.path;
    } else {
      navigate(option.path);
    }
  };

  if (!displayFooter) return <></>;

  return (
    <footer>
      <Box
        sx={{
          bgcolor: (currTheme) => currTheme.palette.footerBackground,
          width: '100%',
          height: '100%',
          pt: 10,
          pb: 5,
        }}>
        <Box
          sx={{
            maxWidth: (currTheme) => currTheme.breakpoints.values.lg,
            mx: 'auto',
          }}>
          <Grid container align='center' justifyContent='center' spacing={5}>
            <Grid item xs={12} md={12} lg={12} xl={3} sx={{}}>
              <Button
                disableRipple
                onClick={() => {
                  navigate('/');
                }}>
                <img
                  src={OasisLogo}
                  alt='OasisApp'
                  style={{ margin: 'auto' }}
                />
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                variant='body2'
                gutterBottom
                align='center'
                sx={{
                  color: (currTheme) => currTheme.palette.grey[300],
                }}>
                Menu
              </Typography>
              <List dense>
                {footerMenuOptions.map((option) => (
                  <ListItem
                    key={option.id}
                    sx={{
                      px: '2em',
                      py: '0',
                    }}>
                    <ListItemText>
                      <Button
                        fullWidth
                        color='inherit'
                        variant='text'
                        sx={{
                          textTransform: 'none',
                          justifyContent: 'flex-start',
                          textAlign: 'left',
                        }}
                        onClick={() => {
                          handleItemClick(option);
                        }}>
                        {option.label}
                      </Button>
                    </ListItemText>
                  </ListItem>
                ))}
              </List>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                variant='body2'
                gutterBottom
                align='center'
                sx={{
                  color: (currTheme) => currTheme.palette.grey[300],
                }}>
                Contacto
              </Typography>
              <List dense>
                {Object.keys(contactData).map((contactKey) => (
                  <ListItem
                    key={contactKey}
                    sx={{
                      px: '2em',
                      py: '0',
                    }}>
                    <ListItemIcon sx={{ minWidth: 'fit-content' }}>
                      {contactData[contactKey].Icon}
                    </ListItemIcon>
                    <ListItemText>
                      <Button
                        fullWidth
                        color='inherit'
                        variant='text'
                        sx={{
                          textTransform: 'none',
                          justifyContent: 'flex-start',
                          textAlign: 'left',
                        }}
                        onClick={() => {
                          window.open(contactData[contactKey].href, '_blank');
                        }}>
                        {contactData[contactKey].label}
                      </Button>
                    </ListItemText>
                  </ListItem>
                ))}
              </List>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                variant='body2'
                gutterBottom
                align='center'
                sx={{
                  color: (currTheme) => currTheme.palette.grey[300],
                }}>
                ¡Síguenos!
              </Typography>
              <SocialMedia justifyContent='center' spacing={2} />
            </Grid>
          </Grid>
          <Stack
            direction='row'
            justifyContent='center'
            alignItems='center'
            sx={{ py: 3 }}>
            <MUILink {...footerStyles} to={menuOptions.TERMSANDCONITIONS.path}>
              Términos y condiciones
            </MUILink>
            <Divider />
            <MUILink {...footerStyles} to={menuOptions.PRIVACY.path}>
              {/** TODO: Aviso de privacidad */}
              Aviso de Privacidad
            </MUILink>
            <Divider />
            <Typography
              variant='body2'
              sx={{ color: (currTheme) => currTheme.palette.grey[500] }}>
              @{new Date().getFullYear()} Oasis
            </Typography>
          </Stack>
        </Box>
      </Box>
    </footer>
  );
};

Footer.defaultProps = {
  displayFooter: true,
};

Footer.propTypes = {
  displayFooter: PropTypes.bool,
};

export default Footer;
